import { Box, Heading, Text, Button, VStack } from '@chakra-ui/react'

interface ErrorStateProps {
  title?: string
  message: string
  onRetry?: () => void
}

export function ErrorState({ title = 'Error', message, onRetry }: ErrorStateProps) {
  return (
    <Box textAlign="center" py={12}>
      <VStack gap={4}>
        <Heading size="md" color="red.500">
          {title}
        </Heading>

        <Text color="gray.600" maxW="md">
          {message}
        </Text>

        {onRetry && (
          <Button colorPalette="brand" onClick={onRetry}>
            Try again
          </Button>
        )}
      </VStack>
    </Box>
  )
}
